import { createFileRoute } from '@tanstack/react-router'

import { TipPresetsPage } from '#/modules/billing/tip-presets-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/tip-presets')({
  component: TipPresetsPage,
  validateSearch: validateListSearch,
})
